import React from 'react';
import './AppState.css';

/**
 * Catches a module that failed to load or crashed while rendering, and shows a message with a
 * way out, instead of blanking the whole app. `resetKey` (the route) clears the error on
 * navigation, so moving to another module works without a reload.
 */
export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Route failed to render', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const chunk = /Loading (CSS )?chunk|ChunkLoadError|dynamically imported module/i.test(String(this.state.error?.message || this.state.error?.name || ''));
    return (
      <div className="app-state app-state--error app-state--page" role="alert">
        <h2 className="app-state__title">{chunk ? 'This page could not be loaded' : 'Something went wrong on this page'}</h2>
        <p className="app-state__text">
          {chunk
            ? 'The app may have been updated since you opened it. Refreshing loads the latest version.'
            : 'The rest of the app still works. Refreshing usually clears this; if it keeps happening, let the WFM team know what you were doing.'}
        </p>
        <div className="app-state__actions">
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>Refresh</button>
          <a className="btn btn-secondary" href="/home">Go to home</a>
        </div>
      </div>
    );
  }
}
